import angular from 'angular';

angular
  .module('evl-waiting', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('evl-waiting', {
        data: {
          authorizedRole: 'USER_BO'
        }
      });
    }
  ]);
